import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';
import { CalendarComponentOptions, DayConfig } from 'ion2-calendar';

@IonicPage()
@Component({
  selector: 'page-calendar',
  templateUrl: 'calendar.html',
})
export class CalendarPage {
  public calendar: any;
  optionsMulti: any;
  private addCalendar = [];
  private deleteCalendar = [];
  private getCalendars = [];
  private val: any;
  private date: any;
  private availableDates = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {

  }
  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Огноо';
    this.getCal();
  }
  selectChanged(date1: any) {
    const dateObj: Date = new Date(date1);
    this.date = dateObj.getFullYear().toString() + '' +
        ('0' + (dateObj.getMonth() + 1).toString()).slice(-2) + '' +
        ('0' + dateObj.getDate().toString()).slice(-2);
  };

  save() {

    if( !this.val ){
      this.val == null;
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
      return;
    }
    if( !this.date ){
      this.val == null;
      this.showToast1('Тэмдэглэлт өдөр сонгогдоогүй байна!!!');
      return;
    }
    this.rest.addCalendar(this.data.userId, this.val, this.data.companyId, this.date).subscribe(res => {
      this.addCalendar = res;
      this.showToast('Таны сонгосон Тэмдэглэлт өдөр амжилттай нэмэгдлээ.');
      this.getCal();
    });

  }
  getCal(){
    this.getCalendars = [];
    this.availableDates = [];
    this.date = '';
    this.val = '';
    this.rest.getCalendars(this.data.companyId).subscribe(res => {
      // this.getCalendars = res;
      for(let i=0; i < res.calendars.length;i++) {
        if(res.calendars[i].created_at.substring(0,4) >= '2019') {
          this.getCalendars.push(res.calendars[i]);
          this.availableDates.push({date: new Date(res.calendars[i].created_at.substring(0,10)), marked: true, disable: false});
        }
      }
      const optionsMulti: CalendarComponentOptions = {
        monthFormat: 'YYYY он MM сар ',
        monthPickerFormat: ['01сар', '02сар', '03сар', '04сар', '05сар', '06сар', '07сар', '08сар', '09сар', '10сар', '11сар', '12сар'],
        weekdays: ['Ня', 'Да', 'Мя', 'Лх', 'Пү', 'Ба', 'Бя'],
        from: 1,
        to: 0,
        weekStart: 1,
        color:'danger',
        disableWeeks: [0, 6],
        daysConfig: this.availableDates,
      };
      this.optionsMulti = optionsMulti;
    });
  }
  set(calendar: any) {
    let request_sent = this.modalCtrl.create(
      ModalEventSetPage,
      { calendar: calendar },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    request_sent.present().catch(err => {

    });
    request_sent.onDidDismiss((data) => {
      if(data != null) {
        this.getCal();
      }
    });
  }
  delete(calendar: any) {
    if(confirm('Та тухайн тэмдэглэлт өдрийг устгахдаа итгэлтэй байна уу?')) {
      this.rest.deleteCalendar(calendar.id).subscribe(res => {
        this.showToast('Таны сонгосон Тэмдэглэлт өдөр амжилттай устлаа.');
        this. getCal();
      });
    }
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}
@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Тэмдэглэлт өдөр засах</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label>Огноо</ion-label>
            <ion-datetime displayFormat="YYYY-MM-DD" [(ngModel)]="date"></ion-datetime>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Тайлбар</ion-label>
            <ion-textarea [(ngModel)]="val"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
      <br>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="sentRequest()">Засах</button>
          </ion-item>
        </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="backto()">Буцах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
</ion-grid>
</ion-content>
  `
})

export class  ModalEventSetPage {
  private date: any;
  private val: any;
  public calendar: any;
  public calendarId: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController)
  {
    this.calendar = this.navParams.get('calendar');
    if(this.calendar != null) {
      this.calendarId = this.calendar.id;
      this.val = this.calendar.val;
      this.date = new Date(this.calendar.created_at.substring(0,10)).toISOString();
    }
  }

  sentRequest(){
    if( !this.date ){
      this.date == null;
      this.showToast1('Өдөр сонгогдоогүй байна!!!');
      return;
    }
    if( !this.val ){
      this.val == null;
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
      return;
    }
    this.rest.editCalendar(this.data.userId, this.val, this.calendarId, this.date).subscribe(res => {
      if(res.msg == 'ok') {
        this.showToast('Тэмдэглэлт өдөр амжилттай засагдлаа.');
      }
    });
  this.viewCtrl.dismiss({data: 'edit'});
  }

  backto(){
    this.viewCtrl.dismiss(null);
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}




// WEBPACK FOOTER //
// ./src/pages/calendar/calendar.ts